<h1 mat-dialog-title>
  {{ message() }}
</h1>

<div mat-dialog-content>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
